
























import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'

export type InstitutionInputs = {
  name: string
  patientId: string
}

const createNewInstitution = () => ({
  name: '',
  patientId: ''
})

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class InstitutionInputGroup extends mixins(InputGroup) {
  @Prop({ type: Array, default: () => [] }) value!: Array<InstitutionInputs>

  get isMaximumLength() {
    return this.value.length > 2
  }

  handleClickAdd() {
    if (this.isMaximumLength) {
      return
    }
    this.value.push(createNewInstitution())
  }

  handleClickDelete(index: number) {
    this.value.splice(index, 1)
    this.$delete(this.validator.evaluators, `institution${index + 1}Name`)
    this.$delete(this.validator.evaluators, `institution${index + 1}PatientId`)
  }

  created() {
    if (this.value.length === 0) {
      this.value.push(createNewInstitution())
    }
  }
}
